import { render, staticRenderFns } from "./PolicyPaymentDateSelection.vue?vue&type=template&id=0b2fa258&"
import script from "./PolicyPaymentDateSelection.vue?vue&type=script&lang=js&"
export * from "./PolicyPaymentDateSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports